import classNames from "classnames"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { useState } from "react"
import { collapseSidePanel, expandSidePanel } from "./slice.new"
import * as Icons from "@nova/component-icons"
import { ButtonFloating } from "@nova/component-btn"
import { selectActiveContextMenu } from "features/popups/contextMenu"
import { setActiveContextMenu } from "features/popups/slice"

export function CollapseSidePanelButton() {
    const dispatch = useAppDispatch()
    const [isHovering, setIsHovering] = useState(false)
    const activeSidePanelContextMenu = useAppSelector(selectActiveContextMenu("SidePanelItem"))
    return (
        <button
            className={classNames(
                "flex gap-1 justify-center items-center rounded transition-all duration-100",
                {
                    "text-gray-500": !isHovering,
                    "text-white-1000": isHovering,
                }
            )}
            onClick={() => {
                if (activeSidePanelContextMenu) {
                    dispatch(setActiveContextMenu(undefined))
                }
                dispatch(collapseSidePanel())
            }}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            <h5
                className={classNames("transition-opacity duration-100", {
                    "opacity-0": !isHovering,
                    "opacity-100": isHovering,
                })}
            >
                Close
            </h5>
            <Icons.Icon Icon={Icons.LeftPanelClose} />
        </button>
    )
}

export function ExpandButton({
    onClick,
    hoverColor = "#FFF",
    reverse,
    textOnHoverOnly,
}: {
    onClick: () => void
    hoverColor?: string
    reverse?: boolean
    textOnHoverOnly?: boolean
}) {
    const [isHovering, setIsHovering] = useState(false)
    return (
        <button
            className={classNames(
                "flex gap-1 justify-center items-center rounded transition-all duration-100",
                {
                    "text-gray-500": !isHovering,
                    "flex-row-reverse": reverse,
                }
            )}
            style={{
                color: isHovering ? hoverColor : undefined,
            }}
            onClick={onClick}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            <Icons.Icon Icon={Icons.LeftPanelOpen} />
            {(!textOnHoverOnly || isHovering) && <h5>Open</h5>}
        </button>
    )
}

export function ExpandSidePanelButton() {
    const dispatch = useAppDispatch()
    const activeSidePanelContextMenu = useAppSelector(selectActiveContextMenu("SidePanelItem"))
    return (
        <ExpandButton
            onClick={() => {
                if (activeSidePanelContextMenu) {
                    dispatch(setActiveContextMenu(undefined))
                }
                dispatch(expandSidePanel())
            }}
        />
    )
}

export function FloatingExpandSidePanelButton() {
    const dispatch = useAppDispatch()
    const activeSidePanelContextMenu = useAppSelector(selectActiveContextMenu("SidePanelItem"))
    return (
        <ButtonFloating
            LeftIcon={Icons.LeftPanelOpen}
            title="Open"
            onClick={() => {
                if (activeSidePanelContextMenu) {
                    dispatch(setActiveContextMenu(undefined))
                }
                dispatch(expandSidePanel())
            }}
        />
    )
}
